import { Link } from "react-router-dom";
import { User, Store, ArrowRight, Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import useSeo from "@/hooks/useSeo";

const options = [
  {
    to: "/download", tone: "teal", icon: User, title: "Personal",
    body: "Start with Orrbbit Free: 500m Radar and five Vibes. Pro unlocks every Vibe and up to 1km, with a 7-day trial for eligible new subscribers.",
    points: ["People Mode discovery", "Events nearby", "Verified Meetup Spots", "Consent-based & privacy-first"],
    cta: "Get the People app",
  },
  {
    to: "/business", tone: "cobalt", icon: Store, title: "Business",
    body: "Create your Business profile. Eligible new subscribers receive seven days free, then A$9.99/month or the local store equivalent. Verification approval is required.",
    points: ["Verified Business Profile", "Host Business Events", "Nearby event discovery", "Desktop + mobile dashboard"],
    cta: "Continue as Business",
  },
];

export default function GetStarted() {
  useSeo({ title: "Get Started — Orrbbit", description: "Get started with Orrbbit as a Personal account or a Business.", path: "/get-started" });
  return (
    <div data-testid="get-started-page">
      <section className="container-x section-space">
        <Reveal className="mx-auto max-w-2xl text-center">
          <h1 className="font-heading text-4xl font-bold tracking-tight text-navy md:text-5xl">Get started with Orrbbit</h1>
          <p className="mt-4 text-bodygrey">Choose how you'd like to join.</p>
        </Reveal>
        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2">
          {options.map((o, i) => {
            const Icon = o.icon;
            const cobalt = o.tone === "cobalt";
            return (
              <Reveal key={o.title} delay={i * 0.08}>
                <div className={`flex h-full flex-col rounded-3xl border bg-white p-8 shadow-soft ${cobalt ? "border-cobalt/30" : "border-teal/30"}`} data-testid={`get-started-${o.tone}`}>
                  <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${cobalt ? "bg-cobalt/10 text-cobalt" : "bg-teal/10 text-teal"}`}><Icon size={24} /></span>
                  <h2 className="mt-6 font-heading text-2xl font-semibold text-navy">{o.title}</h2>
                  <p className="mt-2 text-bodygrey">{o.body}</p>
                  <ul className="mt-5 flex-1 space-y-2">
                    {o.points.map((p) => (
                      <li key={p} className="flex items-start gap-2 text-sm text-navy"><Check size={15} className={`mt-0.5 flex-none ${cobalt ? "text-cobalt" : "text-teal"}`} /> {p}</li>
                    ))}
                  </ul>
                  <Link to={o.to} className={`mt-7 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-semibold text-white transition-transform hover:scale-[1.02] ${cobalt ? "bg-cobalt" : "bg-teal"}`}>{o.cta} <ArrowRight size={16} /></Link>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}

